import { OnContextFetchError, OnSetContext } from './context.types'

export const FETCH_CONTEXT_ERROR = 'FETCH_CONTEXT_ERROR'
export const SET_CONTEXT = 'SET_CONTEXT'

export const onSetContext: OnSetContext = context => ({
  payload: context,
  type: SET_CONTEXT
})

export const onContextFetchError: OnContextFetchError = error => ({
  payload: {
    error
  },
  type: FETCH_CONTEXT_ERROR
})
